import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import DisplayLogo from './LogoDisplay';






export default function Hero() {
  return (
    <Box
      id="hero"
      sx={{
        width: '100%',
        margin: "auto",
        backgroundSize: '100% 20%',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 10, sm: 15 },
          pb: { xs: 8, sm: 12 },
        }}
      >
        <DisplayLogo width={{xs:150, md: 200}} height={{xs: 150, md: 200}}/>
    
      </Container>
    </Box>
    
      
    
  );
}
